import { useState, useEffect, useMemo, useCallback } from 'react';
import { Formik, Form } from 'formik';
import { Link, useParams, useHistory } from 'react-router-dom';
// Layouts
import { SidebarLayout } from 'layouts/Sidebar/SidebarLayout';
import ButtonComponent from 'components/design-system/Button/Button';
import Heading from 'components/design-system/Heading/Heading';
import IconButtonComponent from 'components/design-system/IconButton/IconButton';
import { ChevronLeft } from '@mui/icons-material';
// Schema

// Components
import CamposGrupos from './CamposGrupos';
// Views

import { DICTONARY } from 'const/Dictonary';
import { RUTAS } from 'const/Rutas';
import { useSubmitGrupos } from '../../hooks/useSubmitGrupos';
import { SkeletonGrupos } from '../../skeleton/SkeletonGrupos';
import { diccionarioVista } from '../../utils/utils';
import { useServicesGrupos } from 'views/Grupos/hooks/useServicesGrupos';
import { schemaGrupos } from 'views/Grupos/schema/schemaGrupos';

const GruposFormik = () => {
  const params = useParams();

  const history = useHistory();

  const { location } = history;

  const [codigoGrupo, setCodigoGrupo] = useState(params.codigoGrupo || 'nuevo');

  const [operacionFinalizada, setOperacionFinalizada] = useState(false);

  // Tipo de Formulario
  const tipo = location?.state?.formulario?.tipo;

  const [tipoFormulario, setTipoFormulario] = useState(tipo || '');
  const [validating, setValidating] = useState(false);
  // Hooks
  const {
    grupos,
    isLoading,
    setIsLoading,
    cargarGrupo,
    cargaData,
    handleSubmit,
    handleEliminarGrupo
  } = useSubmitGrupos(codigoGrupo);

  const {
    //Funciones
    ObtieneListaEmpresas,
    // States
    empresas,
    isLoadingEmpresas
  } = useServicesGrupos();

  const cargarEmpresas = useCallback(async () => {
    ObtieneListaEmpresas();
  }, [ObtieneListaEmpresas]);

  useEffect(() => {
    cargarEmpresas();
  }, [cargarEmpresas]);

  // ejecutar cargarGrupo() si se refresca la pagina
  useEffect(() => {
    if (!tipoFormulario) return;
    cargarGrupo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tipoFormulario]);

  useEffect(() => {
    if (!cargaData) return;
  }, [cargaData, isLoading, grupos]);

  // Tipos de Formulario
  const tiposPosibles = ['ingresar', 'editar'];

  // Asegurar que tipoFormulario tenga un valor por defecto
  const tipoFormularioNormalizado = tiposPosibles.includes(tipoFormulario)
    ? tipoFormulario
    : 'ingresar';

  // Reducir a un objeto que indica cuál tipo es true
  const tipoForm = tiposPosibles.reduce((obj, tipo) => {
    obj[tipo] = tipoFormularioNormalizado === tipo;
    return obj;
  }, {});

  // Verificar si el formulario es de tipo 'ingresar'
  const isFormIngresar = tipoFormularioNormalizado === 'ingresar';

  // Correr efecto cuando el tipo de formulario venga del menú
  useEffect(() => {
    if (tipoFormulario === '') {
      setTipoFormulario('ingresar');
      setIsLoading(false);
    } else {
      return;
    }
  }, [setIsLoading, tipoFormulario]);

  return (
    <SidebarLayout>
      <Heading type="h2" className="mb-4 text-lg md:text-2xl">
        <div className="flex items-center">
          <Link to={`${RUTAS.ADMINISTRAR_GRUPOS}`}>
            <IconButtonComponent type="secondary" className="mr-2">
              <ChevronLeft />
            </IconButtonComponent>
          </Link>
          <span>{` ${tipoForm.ingresar ? 'Ingresar' : 'Editar'} ${
            diccionarioVista.primerNombrePrincipal
          }`}</span>
        </div>
        {isLoading && !cargaData && !isFormIngresar ? (
          <SkeletonGrupos tipoForm={tipoFormulario} />
        ) : (
          <Formik
            initialValues={grupos}
            validationSchema={schemaGrupos(setValidating)}
            validateOnChange={true}
            validateOnBlur={false}
            validateOnMount={true}
            onSubmit={async (values, { resetForm, validateForm }) => {
              await handleSubmit(values, tipoFormulario);

              // Al ingresar resetear formulario
              if (tipoForm.ingresar) {
                resetForm();
              } else {
                history.push(`${RUTAS.ADMINISTRAR_GRUPOS}`);
              }
              // setOperacionFinalizada(true);
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleReset,
              handleSubmit,
              isSubmitting,
              setFieldError,
              setFieldTouched,
              setFieldValue,
              touched,
              validateForm,
              values
            }) => (
              <Form
                id={`editar${diccionarioVista.primerNombrePrincipal}`}
                onChange={event => {
                  //  console.log('touched ::>', touched);
                  // console.log('errors ::>', errors);
                  //  console.log('values ::>', values);
                  // console.log('validating ::>', validating);
                }}
              >
                <div className="bg-white rounded p-5 shadow-sm mb-5">
                  <div className="grid grid-cols-12 gap-4">
                    <CamposGrupos
                      // Formik
                      errors={errors}
                      handleBlur={handleBlur}
                      handleChange={handleChange}
                      handleReset={handleReset}
                      handleSubmit={handleSubmit}
                      setFieldError={setFieldError}
                      setFieldTouched={setFieldTouched}
                      setFieldValue={setFieldValue}
                      touched={touched}
                      validateForm={validateForm}
                      values={values}
                      isSubmitting={isSubmitting}
                      tipoForm={tipoForm}
                      // Dependencias
                      permisos={grupos}
                      isLoadingPermisos={isLoading}
                      // Empresas
                      empresas={empresas}
                      isLoadingEmpresas={isLoadingEmpresas}
                      validating={validating}
                    />

                    <div className="col-span-12 justify-between">
                      <div className="flex justify-between">
                        <Link to={`${RUTAS.ADMINISTRAR_GRUPOS}`}>
                          <ButtonComponent type="secondary" className="mr-2">
                            <ChevronLeft /> Volver
                          </ButtonComponent>
                        </Link>

                        {operacionFinalizada ? (
                          <Link to={`${RUTAS.ADMINISTRAR_GRUPOS}`}>
                            <ButtonComponent type="primary" className="mr-2">
                              Finalizar
                            </ButtonComponent>
                          </Link>
                        ) : (
                          <ButtonComponent
                            form={`editar${diccionarioVista.primerNombrePrincipal}`}
                            buttonType="submit"
                            isLoading={isSubmitting || isLoading}
                            disabled={
                              isSubmitting ||
                              validating || // Mientras se esté validando cualquier campo
                              (touched.name && errors.name) || // Si el campo name ha sido tocado y tiene errores
                              (touched.empresas && errors.empresas) || // Si el campo empresas ha sido tocado y tiene errores
                              Object.keys(errors).length > 0 // Si hay errores en cualquier campo
                            }
                          >
                            {tipoFormulario === 'ingresar'
                              ? DICTONARY.MENSAJES_BOTONES_ACCIONES_CRUD
                                  .INGRESAR
                              : tipoFormulario === 'editar'
                              ? DICTONARY.MENSAJES_BOTONES_ACCIONES_CRUD.EDITAR
                              : ''}
                          </ButtonComponent>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        )}
      </Heading>
    </SidebarLayout>
  );
};

export default GruposFormik;
